import httpInstance from '../httpInstance';

const deleteCommissionService = async (id) => {
  let res;
  const endpoint = `/back-office/v1/commissions/id/${id}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteCommissionService;
